// extracted by mini-css-extract-plugin
module.exports = {"sublabel":"AnswerInputPreview_sublabel_2ZtxI","subtext":"AnswerInputPreview_subtext_N4VE6"};